<script context="module" lang="ts">
  export type SelectOption = { label: string; value: string };
</script>

<script lang="ts">
  import Select from '../Select.svelte';
  import Text from '../Text.svelte';

  export let label: string;
  export let placeholder: string | undefined = undefined;
  export let options: SelectOption[] | [] = [];
  export let selectedOption: string;
  export let labelOnTop: boolean = false;
  export let description = '';
</script>

<div class="select-wrapper" class:align-top={labelOnTop}>
  <Text tagName="label" size="medium" bold={!labelOnTop} for={label}>{label}</Text>
  <Select id={label} {options} on:change bind:placeholder bind:selectedOption />
  {#if description}
    <Text tagName="span" size="small" color="tertiary">
      {description}
    </Text>
  {/if}
</div>

<style lang="scss">
  @use '../../styles/spacing';
  .select-wrapper {
    display: flex;
    justify-content: space-between;
    gap: spacing.$xxs;
    align-items: center;
  }

  .align-top {
    width: 100%;
    flex-direction: column;
    align-items: normal;
  }
</style>
